import React, { FC, memo } from 'react'
import { toDecimal } from '@dt/fe-utils'
import './index.scss'

// props
interface IProps {
  /** 值 */
  value: string;
  /** change事件 */
  onChange?: (value: string) => void;
}

// item props
interface IItemProps {
  /** 值 */
  value: number;
  /** click事件 */
  onClick: (value: number) => void;
}

// 数字键盘项
const Item: FC<IItemProps> = memo(({ value, onClick }) => {
  const handleClick = () => {
    onClick(value)
  }
  return <li data-cypid={`keyboard_${value}`} onClick={handleClick}>{value}</li>
})

const Keyboard: FC<IProps> = ({ value, onChange }) => {
  // 输入数字
  const inputDigit = (digit: number) => {
    if (window.bo === 'cn') {
      const splitArr: any[] = value.split('.')
      if (parseFloat(value) === 0) {
        if (!splitArr[1] || (splitArr[1] && splitArr[1].length < 2)) {
          if (splitArr[1] === undefined) {
            onChange('0')
          } else {
            onChange(value + String(digit))
          }
        } else {
          onChange(String(digit))
        }
      } else {
        if (!splitArr[1] || (splitArr[1] && splitArr[1].length < 2)) {
          onChange(value + String(digit))
        }
      }
    } else {
      let newStr = String(toDecimal((parseFloat(value) || 0) * 100))
      newStr += digit
      onChange(toDecimal(parseFloat(newStr || '0') / 100, 2, true))
    }
  }

  // 输入点
  const inputPoint = () => {
    if (value.indexOf('.') !== -1) return
    onChange(value + '.')
  }

  // 退格
  const backspace = () => {
    if (value.length > 0) {
      if (window.bo === 'cn') {
        onChange(value.substr(0, value.length - 1))
      } else {
        let newStr = String(toDecimal((parseFloat(value) || 0) * 100))
        newStr = newStr.substr(0, newStr.length - 1)
        onChange(toDecimal(parseFloat(newStr || '0') / 100, 2, true))
      }
    }
  }

  return (
    <ul className='key-board'>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(x => (
        <Item key={x} value={x} onClick={inputDigit} />
      ))}
      {window.bo === 'cn' && <li data-cypid='keyboard_point' onClick={inputPoint}>.</li>}
      {window.bo === 'us' && <li></li>}
      <Item value={0} onClick={inputDigit} />
      <li data-cypid='keyboard_backspace' onClick={backspace}>
        <i className='iconfont icon-backspace' />
      </li>
    </ul>
  )
}

export default memo(Keyboard)
